import { Outlet } from "react-router"
import { SharedRateSheetsLayout } from "../../../../RateSheets"
import { useSearchParams } from "../../../../router-utils"

export type TSharedRateSheetsOutletContext = { guestToken: string }

export default function Layout() {
	const [searchParams] = useSearchParams()
	const guestToken = searchParams.get("guest_token") || ""

	return (
		<SharedRateSheetsLayout guestToken={guestToken}>
			<Outlet
				context={{ guestToken } satisfies TSharedRateSheetsOutletContext}
			/>
		</SharedRateSheetsLayout>
	)
}
